module.exports = __webpack_public_path__ + "img/icon_map_32_off_011.a49ba133.png";